// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable camelcase */ // TODO: to be removed in a separate PR post nextjs upgrade is complete
import { capitalizeWords, addDashesToPhoneNumber } from './utils';

const parseStoreAddress = (payload) => {
  const { address1, address2, city, stateCode, postalCode, c_storeName, storePhoneNo } = payload;

  const parsedAddress1 = capitalizeWords(address1);
  const parsedAddress2 = address2 && capitalizeWords(address2);
  const parsedCity = capitalizeWords(city);
  const parsedStateCode = stateCode && stateCode.toUpperCase();
  const parsedPhoneNumber = storePhoneNo && addDashesToPhoneNumber(storePhoneNo);
  return {
    address1: parsedAddress1,
    address2: parsedAddress2,
    city: parsedCity,
    stateCode: parsedStateCode,
    postalCode,
    c_storeName,
    storePhoneNo: parsedPhoneNumber,
  };
};

export default parseStoreAddress;
